import script from "./ElementPersonInCharge.vue?vue&type=script&setup=true&lang=ts"
export * from "./ElementPersonInCharge.vue?vue&type=script&setup=true&lang=ts"

import "./ElementPersonInCharge.vue?vue&type=style&index=0&id=57f3cf6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57f3cf6c"]])

export default __exports__